export default __webpack_public_path__ + "static/image-colocation-65e1d03d7e4de96935b0df81c282ea1d.png";